export default "__VITE_ASSET__vuWa1bFl__"